module.exports = __webpack_public_path__ + "img/loginIcon.d0896cbb.png";